<item-full-modal
    modalTitle="{{ l10nKeys.modalHeader | vtranslate }}"
    [item]="editable"
    [form]="form"
    (onSubmit)="submit()"
>
    <form 
        clrForm 
        [clrLayout]="verticalLayout" 
        #form="ngForm"
    >
        <!-- General -->
        <full-modal-tab-section tabTitle="{{ globalL10nKeys.generalLabel | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ globalL10nKeys.generalLabel | vtranslate }}</h3>
                <gslb-client-ip-addr-group-config
                    [clientIpAddrGroup]="editable.config.client_ip_addr_group"
                ></gslb-client-ip-addr-group-config>
            </div>
        </full-modal-tab-section>
    </form>
</item-full-modal>
